// extracted by mini-css-extract-plugin
export default {"tooltip":"XQ-z","arrow":"YQ-z"};